import promise from '@/axios/promise'
import qs from 'qs'

export function getText (apiUrl) {
  return promise({
    url: apiUrl,
    method: 'get'
  })
}

export function postText (apiUrl, datatext) {
  return promise({
    url: apiUrl,
    method: 'post',
    data: qs.stringify(datatext)
  })
}

export function queryText (apiUrl, datatext) {
  return promise({
    url: apiUrl,
    method: 'get',
    data: qs.stringify(datatext)
  })
}

export function axis (apiUrl, method, queryData) {
  return promise({
    url: apiUrl,
    method: method,
    data: queryData
  })
}

export function setCostTypeText (apiUrl, costTypeMinor) {
  return promise({
    url: apiUrl,
    method: 'post',
    data: qs.stringify(costTypeMinor)
  })
}



// WEBPACK FOOTER //
// ./src/axios/util.js